module.exports = __webpack_public_path__ + "img/norven_simbolo_branco.8e934c92.png";